<template>
  <div>
       <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ $route.name }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb />
                </nav>
                </b-col>
            </b-row>
        </base-header>
           <b-container fluid class="mt--6">
            <b-row>
                <b-col lg="12">
                    <b-card>
                        <div slot="header">
                            <h3>{{language_terms['BASIC_INFORMATION']}}</h3>
                        </div>
                        <price-setup></price-setup>
                    </b-card>
                </b-col>
            </b-row>
           </b-container>
  </div>
</template>

<script>
import PriceSetup from '../Components/priceSetup.vue'
import { mapState } from "vuex";
export default {
        computed:{
         ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
         })
    },
    components:{
        PriceSetup

    }
    

}
</script>

<style>

</style>